// A mechanical hint, not a semantic verdict. More than 20% pronoun-count drift,
// or any change in the set of known character names, asks the author to review.
export function hasRefinementReferenceChange(original: string, candidate: string, names: string[] = []): boolean {
  const pronouns = (text: string) => {
    const counts = new Map<string, number>()
    for (const word of text.match(/我们|你们|他们|她们|它们|我|你|他|她|它|\b(?:i|me|my|mine|we|us|our|ours|you|your|yours|he|him|his|she|her|hers|they|them|their|theirs)\b/gi) ?? []) {
      const key = word.toLowerCase()
      counts.set(key, (counts.get(key) ?? 0) + 1)
    }
    return counts
  }
  const before = pronouns(original)
  const after = pronouns(candidate)
  const keys = new Set([...before.keys(), ...after.keys()])
  let changed = 0
  let total = 0
  for (const key of keys) {
    changed += Math.abs((before.get(key) ?? 0) - (after.get(key) ?? 0))
    total += Math.max(before.get(key) ?? 0, after.get(key) ?? 0)
  }
  return (total > 0 && changed / total > 0.2) || names.some((name) => name.trim() && original.includes(name) !== candidate.includes(name))
}
